// extracted by mini-css-extract-plugin
export var addressInformationBubbleContainer = "_jo-0";
export var buttonContainer = "_jo-3";
export var cancelButton = "_jo-4";
export var headerSection = "_jo-6";
export var headerTitle = "_jo-9";
export var messageSideLeft = "_jo-1";
export var messageSideRight = "_jo-2";
export var orderNumberContainer = "_jo-7";
export var orderNumberLabel = "_jo-8";
export var submitButton = "_jo-5";